import { z } from 'zod';

import {
  nonEmptyStringSchema,
  nonEmptyStringSchemaWithCustomMessage,
} from 'common/zod/schemas';

import locales from './locales';

export const getBankAccountFormSchema = (bankAccountNames: string[]) =>
  z.object({
    illustrationName: nonEmptyStringSchema,
    name: nonEmptyStringSchemaWithCustomMessage(locales.errors.required)
      .max(30, {
        message: locales.errors.maxLengthExceeded,
      })
      .regex(/^[a-zA-Z0-9À-ÿ .]*$/, {
        message: locales.errors.onlyLettersNumbers,
      })
      .refine((name) => !bankAccountNames.includes(name.trim().toLowerCase()), {
        message: locales.errors.nameAlreadyExists,
      }),
  });

export type BankAccountFormSchema = z.infer<
  ReturnType<typeof getBankAccountFormSchema>
>;
